export default __webpack_public_path__ + "static/media/checkbox-checked.cd613c93.svg";